import { API } from '@utils/axios'

export async function fetchCustomerQuestions (params: any) {
  const response = await API.get('/CustomerQuestion/GetList', { params })
  return response.data
}

export async function downloadCustomerQuestions (params: any) {
  const response = await API.get('/CustomerQuestion/Download', { params, responseType: 'blob' })
  return response.data
}

export async function getNewQuestionCount () {
  const response = await API.get('/CustomerQuestion/GetNewQuestionCount')
  return response.data
}

export async function markWaitingForAnswer () {
  const response = await API.get('/CustomerQuestion/MarkWaitingForAnswer')
  return response.data
}
